"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupedProducts = void 0;
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _internal = require("../../hooks/internal");
var _jsxRuntime = require("react/jsx-runtime");
const GroupedProducts = () => {
  const {
    currentProduct: {
      code,
      groupedProducts
    },
    onGroupedProductCodeClick
  } = (0, _internal.useProduct)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.GroupedProducts, {
    groupedProducts: groupedProducts,
    currentProductCode: code,
    onProductClick: onGroupedProductCodeClick
  });
};
exports.GroupedProducts = GroupedProducts;